import type { SchemaInspector } from ".";
import type { MutatingScreenKind } from "../common/description";
import { ActionKind, hasInputContext } from "../common/description";
import { getFeatureSetting } from "../common/feature-settings";

const primitiveActionKinds: readonly ActionKind[] = [
    // NOTE: The first item here is the "default" action, so don't move it.
    ActionKind.PushDetailScreen,
    ActionKind.PushEditScreen,
    ActionKind.FormScreen,
    ActionKind.PushFreeScreen,
    ActionKind.CopyToClipboardWithArgs,
    ActionKind.OpenLinkWithArgs,
    ActionKind.OpenMapWithArgs,
    ActionKind.PhoneCallWithArgs,
    ActionKind.TextMessageWithArgs,
    ActionKind.ShowShareSheetWithArgs,
    ActionKind.SendEmailWithArgs,
    ActionKind.AddRow,
    ActionKind.SetColumns,
    ActionKind.DeleteRow,
    ActionKind.Zapier,
    ActionKind.Reshuffle,
    ActionKind.Increment,
    ActionKind.SignIn,
    ActionKind.PopScreen,
    ActionKind.CloseModal,
    ActionKind.NavigateToTab,
    ActionKind.ShowToast,
    ActionKind.DeliverEmail,
    ActionKind.ScanCode,
    ActionKind.LiveScanLinearBarcode,
    ActionKind.PlaySound,
    ActionKind.Webhook,
    // legacy - these have to be in here, or we refuse to build them
    ActionKind.OpenLink,
    ActionKind.PhoneCall,
    ActionKind.TextMessage,
    ActionKind.CopyToClipboard,
    ActionKind.OpenMap,
    ActionKind.SendEmail,
    ActionKind.ShowShareSheet,
    ActionKind.OpenWebView,
];

const primitiveActionKindsWithDebug: ActionKind[] = ([] as ActionKind[]).concat(primitiveActionKinds, [
    ActionKind.Alert,
]);

export function getPrimitiveActionKinds(
    screenHasInputContext: boolean,
    appHasUserProfiles: boolean
): readonly ActionKind[] {
    let kinds = getFeatureSetting("debugActions") ? primitiveActionKindsWithDebug : primitiveActionKinds;
    if (!screenHasInputContext) {
        kinds = kinds.filter(
            // FIXME: Filter it out here, too
            k => k !== ActionKind.AddRow && k !== ActionKind.DeleteRow && k !== ActionKind.PushDetailScreen
        );
    }
    if (appHasUserProfiles) {
        kinds = [...kinds, ActionKind.PushUserProfileScreen];
    }
    return kinds;
}

export function getDefaultPrimitiveActionKinds(
    schema: SchemaInspector | undefined,
    mutatingScreenKind: MutatingScreenKind | undefined
): readonly ActionKind[] {
    return getPrimitiveActionKinds(
        hasInputContext(mutatingScreenKind),
        schema === undefined || schema.userProfileTableInfo !== undefined
    );
}
